import LoadPanel from './LoadPanel';
export default LoadPanel;
